import {Injectable} from '@angular/core';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {WindowRefService} from './../window-ref.service';
import {ApiService} from './api.service';
import {TrackingService} from './tracking.service';
import {find} from 'lodash';

@Injectable({
    providedIn: 'root'
})
export class PciCardService {

    public readonly urlApi: string = 'https://service.pcibooking.net/api/payments/capturecard';
    protected listLangs: Array<any> = [
        {'Language': 'Afrikaans', 'ShortcutLocal': 'af', 'Shortcut': 'af', 'TextDirection': 'LTR'}
        , {'Language': 'Arabic', 'ShortcutLocal': 'ar', 'Shortcut': 'ar', 'TextDirection': 'RTL'}
        , {'Language': 'Catalan', 'ShortcutLocal': 'ca', 'Shortcut': 'ca', 'TextDirection': 'LTR'}
        , {'Language': 'Chinese', 'ShortcutLocal': 'zh', 'Shortcut': 'CN', 'TextDirection': 'LTR'}
        , {'Language': 'Chinese (Taiwan)', 'ShortcutLocal': 'ct', 'Shortcut': 'ct', 'TextDirection': 'LTR'}
        , {'Language': 'Croatian', 'ShortcutLocal': 'hr', 'Shortcut': 'hr', 'TextDirection': 'LTR'}
        , {'Language': 'Czech', 'ShortcutLocal': 'cs', 'Shortcut': 'cs', 'TextDirection': 'LTR'}
        , {'Language': 'Danish', 'ShortcutLocal': 'da', 'Shortcut': 'da', 'TextDirection': 'LTR'}
        , {'Language': 'Dutch', 'ShortcutLocal': 'NL', 'Shortcut': 'NL', 'TextDirection': 'LTR'}
        , {'Language': 'English', 'ShortcutLocal': 'EN', 'Shortcut': 'EN', 'TextDirection': 'LTR'}
        , {'Language': 'Estonian', 'ShortcutLocal': 'et', 'Shortcut': 'et', 'TextDirection': 'LTR'}
        , {'Language': 'Finnish', 'ShortcutLocal': 'fi', 'Shortcut': 'fi', 'TextDirection': 'LTR'}
        , {'Language': 'French', 'ShortcutLocal': 'FR', 'Shortcut': 'FR', 'TextDirection': 'LTR'}
        , {'Language': 'German', 'ShortcutLocal': 'DE', 'Shortcut': 'DE', 'TextDirection': 'LTR'}
        , {'Language': 'Greek', 'ShortcutLocal': 'el', 'Shortcut': 'el', 'TextDirection': 'LTR'}
        , {'Language': 'Hebrew', 'ShortcutLocal': 'HE', 'Shortcut': 'HE', 'TextDirection': 'RTL'}
        , {'Language': 'Hindi', 'ShortcutLocal': 'hi', 'Shortcut': 'hi', 'TextDirection': 'LTR'}
        , {'Language': 'Hungarian', 'ShortcutLocal': 'hu', 'Shortcut': 'hu', 'TextDirection': 'LTR'}
        , {'Language': 'Italian', 'ShortcutLocal': 'IT', 'Shortcut': 'IT', 'TextDirection': 'LTR'}
        , {'Language': 'Japanese', 'ShortcutLocal': 'JA', 'Shortcut': 'JA', 'TextDirection': 'LTR'}
        , {'Language': 'Korean', 'ShortcutLocal': 'ko', 'Shortcut': 'ko', 'TextDirection': 'LTR'}
        , {'Language': 'Latvian', 'ShortcutLocal': 'lv', 'Shortcut': 'lv', 'TextDirection': 'LTR'}
        , {'Language': 'Lithuanian', 'ShortcutLocal': 'lt', 'Shortcut': 'lt', 'TextDirection': 'LTR'}
        , {'Language': 'Norwegian', 'ShortcutLocal': 'no', 'Shortcut': 'no', 'TextDirection': 'LTR'}
        , {'Language': 'Polish', 'ShortcutLocal': 'pl', 'Shortcut': 'pl', 'TextDirection': 'LTR'}
        , {'Language': 'Portuguese', 'ShortcutLocal': 'pt', 'Shortcut': 'pt', 'TextDirection': 'LTR'}
        , {'Language': 'Portuguese (Brazil)', 'ShortcutLocal': 'pb', 'Shortcut': 'pb', 'TextDirection': 'LTR'}
        , {'Language': 'Russian', 'ShortcutLocal': 'ru', 'Shortcut': 'ru', 'TextDirection': 'LTR'}
        , {'Language': 'Slovak', 'ShortcutLocal': 'sk', 'Shortcut': 'sk', 'TextDirection': 'LTR'}
        , {'Language': 'Slovenian', 'ShortcutLocal': 'sl', 'Shortcut': 'sl', 'TextDirection': 'LTR'}
        , {'Language': 'Spanish', 'ShortcutLocal': 'ES', 'Shortcut': 'ES', 'TextDirection': 'LTR'}
        , {'Language': 'Svedish', 'ShortcutLocal': 'sv', 'Shortcut': 'sv', 'TextDirection': 'LTR'}
        , {'Language': 'Thai', 'ShortcutLocal': 'th', 'Shortcut': 'th', 'TextDirection': 'LTR'}
        , {'Language': 'Turkish', 'ShortcutLocal': 'TR', 'Shortcut': 'TR', 'TextDirection': 'LTR'}
        , {'Language': 'Zulu', 'ShortcutLocal': 'zu', 'Shortcut': 'zu', 'TextDirection': 'LTR'}
    ];
    
    
    constructor(
    protected winRef: WindowRefService,
        protected sanitizer: DomSanitizer,
    ) {}
    
    public getUrl(infos: any) {
        if (infos === undefined)
            return '';
        let language: string = this.getMappinLang(), port: string = this.winRef.nativeWindow.location.port;

        if (!!port) {
            port = ':'.concat(port);
        }
        let params: Array<any> = [
            , {key: 'cvv', val: true}
            , {key: 'removeBaseCss', val: false}
            , {key: 'autoDetectCardType', val: true}
            , {key: 'showOwnerId', val: false}
            , {key: 'autoFocus', val: true}
            , {key: 'ThreeDS', val: false}
            , {key: 'UnavailThreeDSAuth', val: 'Accept'}
            , {key: 'accessToken', val: infos.pciToken}
            , {key: 'language', val: language}
            , {key: 'css', val: 'rs1'}
            , {key: 'brand', val: 'HotelIntelligence'}
            , {key: 'cardTypes', val: infos.cardTypes}
            , {key: 'postMessageHost', val: ''.concat(this.winRef.nativeWindow.location.protocol, '//', this.winRef.nativeWindow.location.hostname, port)}
        ];
        let s = this.urlApi.concat('?', params.map(o => `${o.key}=${encodeURIComponent(o.val)}`).join('&'));
        return this.sanitizer.bypassSecurityTrustResourceUrl(s);
    }
    
     protected getMappinLang(): string {
        let lang: string = this.winRef.appConfigSite.defaultlangue,
            langue = find(this.listLangs, (o: {Language: string, ShortcutLocal: string, Shortcut: string, TextDirection: string}) => {return o.ShortcutLocal.toLowerCase() == lang.toLowerCase()})
            , langMapped = 'EN'
            ;
        if (!!langue) {
            return langue.Shortcut;
        }
        return langMapped;
    }
}
